import { z } from 'zod'
import { Model } from './architecture'

export const DescriptionValidation = z.object({
  value: z.string({ required_error: '[Description] value is required' }),
})

export class Description extends Model {
  static create({ value }: z.infer<typeof DescriptionValidation>) {
    DescriptionValidation.parse({ value })
    return new Description(value)
  }

  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
